import React, { useRef, useState, useEffect } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Card } from 'antd';
import { LeadCard } from '../LeadCard';
import {
  ColumnContent,
  ExtraContainer,
  ExtraTotalBadge,
  LoadingSkeleton,
  LoadingSkeletonContainer,
} from '../styles';
import moment from 'moment';
import { get } from 'lodash';

const ITEM_HEIGHT = 85;
const BUFFER_SIZE = 5;

export const VirtualizedColumn = ({
  column,
  data,
  count,
  isLoading,
  showDrawer,
}) => {
  const containerRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight);
    }
  }, []);

  const handleScroll = (e) => {
    setScrollTop(e.target.scrollTop);
  };

  const getVisibleItems = () => {
    if (!containerHeight) return [];

    const startIndex = Math.max(0, Math.floor(scrollTop / ITEM_HEIGHT) - BUFFER_SIZE);
    const endIndex = Math.min(
      data.length,
      Math.ceil((scrollTop + containerHeight) / ITEM_HEIGHT) + BUFFER_SIZE
    );

    return data.slice(startIndex, endIndex).map((item, index) => ({
      ...item,
      index: startIndex + index,
    }));
  };

  const visibleItems = getVisibleItems();
  const totalHeight = data.length * ITEM_HEIGHT;

  return (
    <Droppable droppableId={`${column.id}`} isDropDisabled={true}>
      {(provided) => (
        <Card
          title={column.name}
          bodyStyle={{ padding: 0, minWidth: 300 }}
          headStyle={column.style}
          extra={
            <ExtraContainer>
              <ExtraTotalBadge
                count={count}
                overflowCount={9999}
              />
            </ExtraContainer>
          }
        >
          <ColumnContent
            ref={(el) => {
              provided.innerRef(el);
              containerRef.current = el;
            }}
            style={{ 
              overflowY: 'auto',
              position: 'relative',
              height: '71vh'
            }}
            onScroll={handleScroll}
            {...provided.droppableProps}
          >
            <div
              style={{
                height: totalHeight,
                position: 'relative',
              }}
            >
              {isLoading ? (
                Array(10)
                  .fill(1)
                  .map((_, index) => (
                    <LoadingSkeletonContainer key={index}>
                      <LoadingSkeleton />
                    </LoadingSkeletonContainer>
                  ))
              ) : (
                visibleItems.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      position: 'absolute',
                      top: item.index * ITEM_HEIGHT,
                      width: '100%',
                    }}
                  >
                    <LeadCard
                      draggableId={item.id}
                      index={item.index}
                      item={item}
                      showDrawer={showDrawer}
                      columnId={column.id}
                    />
                  </div>
                ))
              )}
            </div>
            {provided.placeholder}
          </ColumnContent>
        </Card>
      )}
    </Droppable>
  );
}; 